<template>
  <div id="sensorHistoryDerivativeChart" class="sensorHistoryChartRoot">
  </div>
</template>

<script>
import api from '../../api/api';
import moment from 'moment';

const echarts = require('echarts')
export default {
  name: 'SensorHistoryChart',
  data() {
    return {

    }
  },
  methods: {
    initChart(sensor) {
      api.post("/querySensorHistoryData", sensor).then(response => {
        const data = response.data.data.map(item => [moment(item.date_trunc).toDate(), item.derivative]);
        console.log('sensor sensorHistoryDerivativeChart data', data)
        const myChart = echarts.init(document.getElementById('sensorHistoryDerivativeChart'));
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        xAxis: {
          type: 'time'
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100
          },
          {
            type: 'slider',
            start: 0,
            end: 100
          }
        ],
        series: [
          {
            data: data,
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: {
              width: 2
            }
          }
        ]
      };

      myChart.setOption(option);
      })
      
      
    }
  },
  mounted() {
    const that = this;
  },
  beforeDestroy() {

  }
}
</script>

<style lang="less" scoped>
.sensorHistoryChartRoot{
  width: 100%;
  height: 300px;
}
</style>
